import { render, staticRenderFns } from "./addTPLInsurance.vue?vue&type=template&id=d6b389de"
import script from "./addTPLInsurance.vue?vue&type=script&lang=js"
export * from "./addTPLInsurance.vue?vue&type=script&lang=js"
import style0 from "./addTPLInsurance.vue?vue&type=style&index=0&id=d6b389de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports